/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-06 20:23:25
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-28 15:43:19
 */

import request from "../../utils/request";
import server from "./config";
const uploadUrl = `${server.MS_PATIENT_CONSUMMER}/file/1/upload`;
export default {
    uploadUrl,
    /**
     * 上传数据
     */
    upload: (file, noToast = false) => {
        var formData = new FormData();
        formData.append("file", file);
        return request({
            url: uploadUrl,
            method: "post",
            data: formData,
            noToast
        });
    },
    /**
     * 获取省市区
     */
    getSysRegionTree: params => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/sysregion/1/getSysRegionTree`,
            method: "get",
            params
        });
    },
    /**
     * 获取科室
     */
    getDepartmentList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/dictionary/1/showList`,
            method: "post",
            data
        });
    },
    // 医院
    hospitalList: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/1/hospital/getPageList`,
            method: "post",
            data
        });
    },
    /**
     * 获取职称
     */
    showDoctorTitle: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/doctor/dictionary/1/showDoctorTitle`,
            method: "post",
            data
        });
    },
    /**
     * 获取药店详情
     */
    showMerchantById: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/merchant/{version}/showMerchantById`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/sys.js